import { ClaimItemEntity } from '../entities/entities.types';
import { AppState } from '../root.reducer';

export const getClaimItemById = (state: AppState, id: string): ClaimItemEntity | undefined => {
  if (!state.entities.claimItem) return undefined;
  return state.entities.claimItem[id];
};
